"use client";

import * as AccordionPrimitive from "@radix-ui/react-accordion";
import AccordionTrigger from "./AccordionTrigger";
import AccordionContent from "./AccordionContent";
import AccordionItem, { AccordionItemProps } from "./AccordionItem";

const Accordion = AccordionPrimitive.Root;

export { Accordion, AccordionTrigger, AccordionContent, AccordionItem };
export type { AccordionItemProps };
